// extracted by mini-css-extract-plugin
module.exports = {"container":"Input_container__DZYWR","input":"Input_input__9oqsG","suffix":"Input_suffix__In4wt"};